import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import "../scss/_soloResources.scss";

function Resources() {
    const { i18n } = useTranslation();
    const resourceData = i18n.getResourceBundle(
        i18n.language,
        "resourcesContainer"
    ).resources;

    const { resourcePageId } = useParams();

    const displayedResource = resourceData.find(
        (resource) => String(resource.id) === resourcePageId
    );

    useEffect(() => {
        const element = document.getElementsByClassName("outerContainer")[0];
        element.scrollIntoView();
    }, [resourcePageId]);

    if (!displayedResource) {
        return <div>404</div>;
    }

    return (
        <div className="outerContainer">
            {displayedResource && (
                <div className="page">
                    <div className="middleContainer">
                        <h1>{displayedResource.title}</h1>
                    </div>
                    <div className="innerContainer">
                        <img
                            src={
                                displayedResource.image.startsWith("http")
                                    ? displayedResource.image
                                    : process.env.PUBLIC_URL +
                                      "/" +
                                      displayedResource.image
                            }
                            alt={displayedResource.alt}
                        />

                        <div className="textContainer">
                            <p>{displayedResource.description}</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Resources;

// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import axios from "axios";
// import "../scss/_soloResources.scss";

// function Resources() {
//     const { resourcePageId } = useParams();
//     const [displayedResource, setDisplayedResource] = useState(null);
//     const [loading, setLoading] = useState(true);

//     useEffect(() => {
//         // Fetch the resource data from the backend
//         axios.get(`http://localhost:5001/api/resources/${resourcePageId}`)
//             .then(response => {
//                 console.log("Data fetched:", response.data);
//                 setDisplayedResource(response.data);
//                 setLoading(false);
//             })
//             .catch(error => {
//                 console.error("There was an error fetching the resource data!", error);
//                 setLoading(false);
//             });
//     }, [resourcePageId]);

//     useEffect(() => {
//         const element = document.getElementsByClassName("outerContainer")[0];
//         element.scrollIntoView();
//     }, [resourcePageId]);

//     if (loading) {
//         return <div>Loading...</div>; // Show loading indicator
//     }
//     if (!displayedResource) {
//         return <div>404</div>;
//     }

//     return (
//         <div className="outerContainer">
//             {displayedResource && (
//                 <div className="page">
//                     <div className="middleContainer">
//                         <h1>{displayedResource.title}</h1>
//                     </div>
//                     <div className="innerContainer">
//                         <img
//                             src={displayedResource.image.url}
//                             alt={displayedResource.image.altText}
//                         />
//                         <div className="textContainer">
//                             <p>{displayedResource.description}</p>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default Resources;
